import {Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ControlContainer, NgForm, NgModelGroup} from '@angular/forms';
import * as _ from 'lodash';
import {AcoesAtividadeService} from "../../../services/acoes-atividade/acoes-atividade.service";
import {Acoes} from "../../../core/acoes";


@Component({
    selector: 'combo-acao-atividade',
    templateUrl: './combo-acao-atividade.component.html',
    styleUrls: ['./combo-acao-atividade.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm},
        {provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup)}],
})
export class ComboAcaoAtividadeComponent implements OnInit {

    @ViewChild('comboAcaoAtividade', {static: false}) comboAcao;

    @Input() showDisplayId;
    @Input() obrigatorio;
    @Input() selecionado;
    @Input() desabilitado;
    @Input() idAtividade;

    @Output() valorChange = new EventEmitter();

    dados = [];
    data: any = {};

    constructor(private acaoService: AcoesAtividadeService) {
    }

    ngOnInit(): void {
        this.data = Date.now();
        this.pesquisarCombo();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.preencherCombo();
        if (changes.idAtividade?.currentValue !== changes.idAtividade?.previousValue)
            this.pesquisarCombo();
    }

    pesquisarCombo() {
        setTimeout(() => {
            if (this.idAtividade) {
                this.acaoService.getComboByIdAtividade(this.idAtividade).subscribe((acaos: Acoes[]) => {
                    this.dados = acaos;
                    this.preencherCombo();
                });
            } else {
                this.acaoService.getAllCombo().subscribe((acaos: Acoes[]) => {
                    this.dados = acaos;
                    this.preencherCombo();
                });
            }
        }, 0);
    }

    private preencherCombo() {
        if (this.selecionado && this.selecionado.id && this.dados.length) {
            this.selecionado = _.find(this.dados, {id: this.selecionado.id});
        }
    }

    onValorChange(registro: any) {
        this.valorChange.emit(registro);
        this.preencherCombo();
    }


}
